var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Helmet from 'react-helmet';
import { MEDIA_QUERIES } from 'shared/style';
import PageComponent from 'components/shared/Page/PageComponent';
import Title from 'components/shared/Title';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
var GET_SUBPAGE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetSubpage($id: String!) {\n    subpage(id: $id) {\n      id\n      name\n      components {\n        id\n        type\n      }\n    }\n  }\n"], ["\n  query GetSubpage($id: String!) {\n    subpage(id: $id) {\n      id\n      name\n      components {\n        id\n        type\n      }\n    }\n  }\n"])));
var RootDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n\n  > .area {\n    > .title {\n      ", " {\n        max-width: 1200px;\n      }\n      ", " {\n        width: 100%;\n      }\n      padding: 50px 20px 0;\n      margin: 0 auto;\n    }\n\n    > .component {\n      padding: 50px 0;\n      clear: both;\n      overflow: hidden;\n\n      :nth-child(odd) {\n        background-color: #f8f8f8;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n\n  > .area {\n    > .title {\n      ", " {\n        max-width: 1200px;\n      }\n      ", " {\n        width: 100%;\n      }\n      padding: 50px 20px 0;\n      margin: 0 auto;\n    }\n\n    > .component {\n      padding: 50px 0;\n      clear: both;\n      overflow: hidden;\n\n      :nth-child(odd) {\n        background-color: #f8f8f8;\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
export default (function (_a) {
    var id = _a.id;
    return (React.createElement(Query, { query: GET_SUBPAGE, variables: { id: id } }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data;
        if (loading)
            return React.createElement(Loading, null);
        if (error || !data.subpage)
            return React.createElement(Error, null);
        var _b = data.subpage, name = _b.name, components = _b.components;
        return (React.createElement(RootDiv, null,
            React.createElement(Helmet, null,
                React.createElement("title", null,
                    "(\uC8FC)\uBAA8\uD604\uC528\uC564\uB514 - ",
                    name),
                React.createElement("meta", { name: "description", content: "{name}" }),
                React.createElement("meta", { name: "og:title", content: "(\uC8FC)\uBAA8\uD604\uC528\uC564\uB514" }),
                React.createElement("meta", { name: "og:description", content: "{name}" }),
                React.createElement("meta", { name: "robots", content: "index, follow" })),
            React.createElement("div", { className: "area" },
                React.createElement("div", { className: "title" },
                    React.createElement(Title, { title: name })),
                components.map(function (component, idx) { return (React.createElement("div", { key: idx, className: "component" },
                    React.createElement(PageComponent, __assign({ subpageId: id }, component)))); }))));
    }));
});
var templateObject_1, templateObject_2;
